import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'

export function FollowUpsFromYesterdayCard(): React.ReactElement {
  const loading = false
  const hasPayload = true
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasPayload)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Follow-ups from yesterday"
      showTitleChevron={false}
      className="dashboard-huddle-followups-card"
      loading={pending}
      skeleton={{ block: 'tall' }}
      isEmpty={isEmpty}
    >
      <div className="dashboard-alerts-list">
        <details>
          <summary>
            <span className="alerts-row-label">Callbacks</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">2</span>
            </span>
          </summary>
          <div className="alerts-row-content">
            <div>Follow up with John Doe re: treatment plan.</div>
            <div>Confirm next visit with Jane Smith.</div>
          </div>
        </details>
        <details>
          <summary>
            <span className="alerts-row-label">Unscheduled treatment</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">1</span>
            </span>
          </summary>
          <div className="alerts-row-content">
            <div>Mark Johnson — hygiene + exam presented, not scheduled.</div>
          </div>
        </details>
        <details>
          <summary>
            <span className="alerts-row-label">Incomplete notes</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">0</span>
            </span>
          </summary>
          <div className="alerts-row-content">All notes signed.</div>
        </details>
      </div>
    </DashboardSectionCard>
  )
}
